import React from 'react';

export const Header = (props) => {

  return(
    <div style={{backgroundColor:"#3b4675",width:"100%", height:60,color:"white", display: "flex",alignItems: "center"}}>
      <div style={{maxWidth: 1200,margin:"0 auto",justifyContent: "space-between",display:"flex",width:"100%",height: 60,alignItems: "center"}}>


      <div style={{letterSpacing: 3,color: "white",fontWeight: 400,fontSize: "1.85rem",marginRight: "auto",minWidth: 100,maxWidth: 250}}>
        <a style={{color:"white",textDecoration:"none"}}href="https://hinoshin-blog.com/">エンジニアLIFE</a>
      </div>
      <div style={{display: props.isMobileScreen ? "none" : "block"}}>
        <ul style={{listStyle: "none",display: "flex",alignItems: "center",height:60,marginBottom: 0,fontWeight: 400}}>
          <li style={{padding: "3px 25px"}}><a style={{color:"white",textDecoration:"none"}} href="https://hinoshin-blog.com/category/programing/">プログラミング</a></li>
          <li style={{padding: "3px 25px"}}><a style={{color:"white",textDecoration:"none"}} href="https://hinoshin-blog.com/category/english/">英語</a></li>
          <li style={{padding: "3px 25px"}}><a style={{color:"white",textDecoration:"none"}} href="https://hinoshin-blog.com/category/lifehack/">ライフハック</a></li>
        </ul>
      </div>
      </div>
    </div>
  )
}
